export const REJECTION_CODE_LABELS = {
    frame_not_found: 'Экран не найден',
    no_bindings: 'Нет привязок',
    data_pivot_missing: 'Ошибка данных',
    data_missing: 'Ошибка данных',
    campaign_status: 'Статус кампании',
    campaign_start_date: 'Дата старта',
    campaign_end_date: 'Дата окончания',
    campaign_schedule: 'Расписание кампании',
    campaign_budget_total: 'Бюджет (общий)',
    campaign_budget_daily: 'Бюджет (дневной)',
    campaign_impr_total: 'Показы (общие)',
    campaign_impr_daily: 'Показы (дневные)',
    ccf_disabled: 'Отключено на экране',
    ccf_schedule: 'Расписание на экране',
    ccf_budget_total: 'Бюджет на экране',
    ccf_budget_daily: 'Дневной бюджет на экране',
    ccf_impr_total: 'Показы на экране',
    ccf_impr_daily: 'Дневные показы на экране',
    no_creative_status: 'Статус креатива',
    no_creative_url: 'URL креатива',
    technical: 'Технические требования',
    duration_too_long: 'Длительность',
    manual_bid_missing: 'Ставка (manual)',
    no_bid: 'Ставка',
    bid_below_floor: 'Ставка ниже минимума',
    insufficient_budget: 'Недостаточно бюджета',
    frequency_blocked: 'Частотный лимит',
    schedule_blocked: 'Расписание / частота',
    cap_zero: 'Запрет показа',
    interval_not_elapsed: 'Интервал между показами',
    frequency_service_error: 'Ошибка сервиса частоты',
    lost: 'Проигрыш в аукционе',
    exception: 'Ошибка сервера',
    superseded_by_cheaper_ssp: 'Слот у более дешёвого SSP',
    arbitration_timeout: 'Таймаут арбитража',
};

export function rejectionCodeLabel(code) {
    if (!code) {
        return 'Причина';
    }
    return REJECTION_CODE_LABELS[code] || code;
}

export function campaignEditUrl(campaignId) {
    if (!campaignId) {
        return null;
    }
    return `/rtb/campaigns/${campaignId}/edit`;
}

function tryParseJson(error) {
    if (typeof error === 'string') {
        try {
            return JSON.parse(error);
        } catch {
            return null;
        }
    }
    if (typeof error === 'object' && error !== null) {
        return error;
    }
    return null;
}

function isStructuredRejectionArray(parsed) {
    return Array.isArray(parsed)
        && parsed.length > 0
        && parsed.every((item) => item && typeof item === 'object' && (item.code !== undefined || item.text !== undefined));
}

function flattenLegacyCampaigns(data) {
    if (!data || !Array.isArray(data.campaigns)) {
        return [];
    }
    const flat = [];
    data.campaigns.forEach((c) => {
        if (c.error) {
            flat.push({
                priority: null,
                code: null,
                text: c.error,
                campaign_id: c.id ?? c.campaign_id ?? null,
                campaign_name: c.name ?? null,
                campaign: c,
            });
        }
        if (Array.isArray(c.errors)) {
            c.errors.forEach((err) => {
                flat.push({
                    priority: null,
                    code: null,
                    text: typeof err === 'string' ? err : (err.message || JSON.stringify(err)),
                    campaign_id: c.id ?? c.campaign_id ?? null,
                    campaign_name: c.name ?? null,
                    campaign: c,
                });
            });
        }
    });
    return flat;
}

/**
 * @param {string|object|null|undefined} error
 * @returns {{ kind: 'structured'|'legacy'|'plain', items: Array, raw: * }}
 */
export function parseErrorPayload(error) {
    if (error === null || error === undefined || error === '') {
        return { kind: 'plain', items: [], raw: error };
    }

    const parsed = tryParseJson(error);

    if (isStructuredRejectionArray(parsed)) {
        const items = parsed
            .map((item) => ({
                priority: item.priority ?? null,
                code: item.code ?? null,
                text: String(item.text ?? ''),
                campaign_id: item.campaign_id ?? null,
                creative_id: item.creative_id ?? null,
                campaign_name: item.campaign_name ?? null,
            }))
            .sort((a, b) => (a.priority ?? 999) - (b.priority ?? 999));

        return { kind: 'structured', items, raw: parsed };
    }

    if (parsed && Array.isArray(parsed.campaigns) && parsed.campaigns.length > 0) {
        return { kind: 'legacy', items: flattenLegacyCampaigns(parsed), raw: parsed };
    }

    const text = typeof error === 'string' ? error : JSON.stringify(error, null, 2);
    return {
        kind: 'plain',
        items: [{ priority: null, code: null, text, campaign_id: null, creative_id: null }],
        raw: error,
    };
}
